import React from 'react';
import Reflux from 'reflux';
import {Button, message, Popconfirm} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {detailReportList,} from '../../service/returnGoods';
import {getReportType} from '../../service/reportForm';
import {objectSerial, config} from 'Utils';
import {getGouXiaoUnitList} from "../../service/traceOrder";
import moment from "moment/moment";

class ReturnGoodsList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.salesChannelCode = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['退货明细报表'],
            showHideBtnIndex: 0,
            key: 0,
            selectedRowKeys: [],
            button_limits_end: {},
            rows: [],
            total: 0,
            searchObj: {
                orderNumber: '',
                channelCode: this.salesChannelCode.split('|')[1] || '',
                status: '',
                cusName: '',
                purchaseName: '',
                qualityBusiness: '',
                returnStartDate: '',
                returnEndDate: '',
                s: 10,
                p: 1,
                productLine: '',
            },
            returnStatusOptions: [],
            productLineOptions: [],
            loading: false
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    };

    /*选择列表*/
    onSelectChange = (selectedRowKeys) => {
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'date') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    returnStartDate: value.from + ' 00:00:00',
                    returnEndDate: value.end + ' 23:59:59'
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*筛选重置*/
    advanceReset() {
        this.setState({
            searchObj: {
                orderNumber: '',
                status: '',
                cusName: '',
                purchaseName: '',
                qualityBusiness: '',
                returnStartDate: '',
                returnEndDate: '',
                channelCode: this.salesChannelCode.split('|')[1] || '',
                s: 10,
                p: 1,
                productLine: '',
            }, loading: true
        }, () => {
            this.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit() {
        if (!this.state.searchObj.returnStartDate || this.state.searchObj.returnStartDate == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        if (!this.state.searchObj.returnEndDate || this.state.searchObj.returnEndDate == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: true
        }, () => {
            this.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        const searchObj = this.state.searchObj;
        detailReportList({...searchObj}).then(result => {
            if (result.status && result.code == 200) {
                this._isMounted && this.setState({
                    rows: result.data || [],
                    total: result.total,
                    loading: false
                });
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        });
    }

    /*导出*/
    export() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/dmsOrderGoback/detailReportExport?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    getReturnStatus = () => {
        getReportType({
            sKey: 'ORDER_GOBACK_STATUS'
        }).then(res => {
            if (res.code === 200) {
                const data = res.data;
                const arr = [{
                    value: '',
                    text: '全部'
                }];
                data.forEach(item => {
                    arr.push({
                        value: item.sKey,
                        text: item.name
                    });
                })
                this.setState({
                    returnStatusOptions: arr
                });
            }
        });
    };

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
        this._isMounted = true;
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    componentDidMount() {
        // this.initData();
        this.getReturnStatus();
        // this.getProductLineOptions();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.name
                    })
                }
                this.setState({gouxiaoUnitList: arr})
            }
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }


    render() {
        var self = this;
        const {opts, key, rows, total, searchObj, selectedRowKeys, showHideBtnIndex, returnStatusOptions, productLineOptions, loading, button_limits_end, gouxiaoUnitList} = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'date',//startCreatedDate, endCreatedDate
                    label: '退货日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.returnStartDate || '',
                        end: searchObj.returnEndDate || ''
                    }
                },
                {
                    name: 'orderNumber',
                    label: '退货编号',
                    text: '输入退货编号',
                    type: 'default',
                    defaultValue: searchObj.orderNumber
                },
                {
                    name: 'purchaseName',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    defaultValue: searchObj.purchaseName,
                    showSearch: true,
                    options: gouxiaoUnitList,
                },
                {
                    name: 'qualityBusiness',
                    label: '退货类型',
                    text: '选择状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: 'Q', text: '质量退货'},
                        {value: 'B', text: '商务退货'},
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.qualityBusiness || ''
                },
                {
                    name: 'productLine',
                    label: '产品线',
                    text: '选择产品线',
                    options: [
                        {value: '', text: '全部'},
                        {value: '01', text: '元器件'},
                        {value: '02', text: '电工'},
                        {value: '03', text: '电表'},
                        {value: '04', text: '变频器'},
                        {value: '05', text: '天e'},
                        {value: '06', text: 'TG精品'},
                    ],
                    multiple: false,
                    showSearch: true,
                    type: 'select',
                    defaultValue: searchObj.productLine || ''
                },
                {
                    name: 'itemNumber',
                    label: '物料编码',
                    text: '输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.itemNumber
                },
                {
                    name: 'itemDesc',
                    label: '物料描述',
                    text: '输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.itemDesc
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '退货编号',
                    dataIndex: 'orderNumber',
                    width: 100
                },
                {
                    title: '退货日期',
                    dataIndex: 'returnDate',
                    width: 90,
                    render: text => <span>{moment(text).format('YYYY-MM-DD')}</span>
                },
                {
                    title: '客户名称',
                    dataIndex: 'cusName'
                },
                {
                    title: '购货单位',
                    dataIndex: 'purchaseName'
                },
                {
                    title: '渠道',
                    dataIndex: 'channelName'
                },
                {
                    title: '产品线',
                    dataIndex: 'productLineName'
                },
                {
                    title: '退货类型',
                    dataIndex: 'qualityBusiness'
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    width: 110
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                },
                {
                    title: '生产公司',
                    dataIndex: 'factoryName'
                },
                {
                    title: '库存属性',
                    dataIndex: 'property'
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '退货数量',
                    dataIndex: 'gobackCount'
                },
                {
                    title: '牌价',
                    dataIndex: 'brandPrice'
                },
                {
                    title: '销售单价',
                    dataIndex: 'sellPrice'
                },
                {
                    title: '销售金额',
                    dataIndex: 'sellMoney'
                },
                {
                    title: '原出库单',
                    dataIndex: 'stockCode'
                },
                {
                    title: '原订单折扣',
                    dataIndex: 'discount'
                },
                {
                    title: '折扣后单价',
                    dataIndex: 'discountPrice'
                },
                {
                    title: '折扣后金额',
                    dataIndex: 'discountMoney'
                },
                {
                    title: '扣点',
                    dataIndex: 'refunds'
                },
                {
                    title: '扣点金额',
                    dataIndex: 'refundMoney'
                },
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.export.bind(this)}>导出</Button>
                </div>
                <TableView {...tableViewProps} />
            </div>
        </div>
    }
}
;
export default withRouter(ReturnGoodsList);



// WEBPACK FOOTER //
// ./src/routes/returnGoods/detailReport.js